import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";
import { InferredData } from "src/app/store/models/right-panel-models";
import { initialState } from "../../store/reducers/right-panel-reducer";

declare function gridRefresh(eventTarget, event);
declare function OnDefaultSetting(sectionName);

@Component({
  selector: "inferred-data-section",
  templateUrl: "./inferred-data-section.component.html",
  styleUrls: ["./inferred-data-section.component.scss"],
})
export class InferredDataSectionComponent implements OnInit {
  actionsDisabled = true;
  originalModel: InferredData = { ...initialState.panels.inferredData };
  tempModel: InferredData = { ...initialState.panels.inferredData };

  constructor(private appService: AppService) {}

  ngOnInit() {
    window.addEventListener("MEDataSet", (rpObj: any) => {
      if (
        rpObj.detail.section === "Adjustments" ||
        rpObj.detail.section === "All"
      ) {
        const data = this.getPanelData(rpObj.detail.data.panels);
        if (data !== undefined) {
          this.setInferrredData(data);
        }
      }
    });
  }

  setInferrredData = (data) => {
    this.originalModel = {
      default: data.default,
      clearDimension: data.clear_dimension,
      selected: data.selected,
    };
    this.tempModel = { ...this.originalModel };
    this.actionsDisabled = true;
  };

  handleApply = (evt) => {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);

    //handles apply button click
    //changes made to tempModel are pushed to MEData
    this.updateMEData(this.tempModel);
    this.setInferrredData(window.MEData.panels[panelIdx]);
    this.tempModel.clearDimension = true;
    gridRefresh(evt.currentTarget, evt);
  };

  handleCancel = () => {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);
    //handles cancel button click
    //revert tempModel to last applied changes
    this.setInferrredData(window.MEData.panels[panelIdx]);
    this.actionsDisabled = true;
  };

  handleCheckChange = (checked: boolean) => {
    //handles checkbox toggle

    this.tempModel.selected = checked ? "implied" : "default";
    this.actionsDisabled = this.appService.compare(
      this.originalModel,
      this.tempModel,
    );
  };

  handleClear = (evt: MouseEvent) => {
    //handles clear button click

    //stop collapsing of inferred data section
    evt.stopImmediatePropagation();
    OnDefaultSetting("Adjustments");
  };

  updateMEData(inferredData: InferredData) {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);

    window.MEData.panels[panelIdx] = {
      ...window.MEData.panels[panelIdx],
      selected: inferredData.selected,
    };

    window.gAdjust = inferredData.selected;
  }

  getPanelData(panelsList) {
    return panelsList.find(
      (panel) => panel.name.toLowerCase() === "adjustments",
    );
  }

  getIndexForPanel(panelsList) {
    return panelsList.findIndex(
      (panel) => panel.name.toLowerCase() === "adjustments",
    );
  }
}
